export default __webpack_public_path__ + "static/media/black-tick.6454a52e.svg";